import { useLocalizedWorkingStepLabel } from 'components/Localization/useLocalizedWorkingStepLabel'
import { isEqual } from 'lodash'
import { matchSorter } from 'match-sorter'
import { useAppSelector } from 'store/configureStore'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { ProjectMaterialPriceSummary } from './MaterialPriceSummary'
import { ProjectWorkingStepPriceSummary } from './WorkingStepPriceSummary'

export const ProjectPriceSummaryDetails = (props: {
  priceSummaryKey: string
  isMaterialVisible: boolean
  isWorkingStepVisible: boolean
  isPurchasingVisible: boolean
  descriptionQuery?: string
  visibleWorkingSteps?: WorkingStepType[]
}) => {
  const { getLocalizedWorkingStep } = useLocalizedWorkingStepLabel()

  const priceSummary = useAppSelector((state: RootAppState) => {
    return state.project.priceSummaries[props.priceSummaryKey]
    // const p = { ...state.project.priceSummaries[props.priceSummaryKey] }
    // p.discountValue = { ...p.discountValue, value: p.discountValue.value * -1 }
    // return p
  }, isEqual)

  if (!props.isMaterialVisible && priceSummary.isMaterial) {
    return null
  }

  if (!props?.isWorkingStepVisible && priceSummary?.isWorkingStep) {
    return null
  }

  if (!props.isPurchasingVisible && priceSummary.isPurchasePart) {
    return null
  }

  if (
    props?.isWorkingStepVisible &&
    props.visibleWorkingSteps?.length > 0 &&
    !props.visibleWorkingSteps.includes(
      priceSummary.workingStep.primaryWorkingStep
    )
  ) {
    return null
  }

  if (props.descriptionQuery) {
    if (
      !matchSorter(
        [
          priceSummary.description,
          priceSummary.materialId,
          priceSummary.workingStep?.resource?.id,
          getLocalizedWorkingStep(priceSummary.workingStep?.primaryWorkingStep),
          getLocalizedWorkingStep(
            priceSummary.workingStep?.secondaryWorkingStep
          ),
        ],
        props.descriptionQuery
      ).length
    ) {
      return null
    }
  }

  if (priceSummary?.isWorkingStep) {
    return <ProjectWorkingStepPriceSummary priceSummary={priceSummary} />
  } else {
    return <ProjectMaterialPriceSummary priceSummary={priceSummary} />
  }
}
